import { render } from "./AncillaryServiceReport.vue?vue&type=template&id=22803b87&ts=true"
import script from "./AncillaryServiceReport.vue?vue&type=script&lang=ts"
export * from "./AncillaryServiceReport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__